export default {
    red : "#c22828",
    grey: "#B0B0B0",
}
